import { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';

import config from '../../config';

export function UnlockPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [token] = useState(searchParams.get('token'));
    const [unlocking, setUnlocking] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (!token) {
            setError('No unlock token provided. Please check your email for the correct unlock link.');
            return;
        }

        // Automatically attempt unlock when component loads
        handleUnlock();
    }, [token]);

    async function handleUnlock() {
        if (!token) return;

        setUnlocking(true);
        setError('');
        setMessage('');

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token })
        };

        try {
            const response = await fetch(`${config.apiUrl}/api/users/unlock`, requestOptions);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to unlock account');
            }

            setSuccess(true);
            setMessage(data.message || 'Account successfully unlocked');
            
            // Redirect to login page after 3 seconds
            setTimeout(() => {
                navigate('/login');
            }, 3000);
            
        } catch (err) {
            setError(err.message || 'An error occurred while unlocking your account');
        } finally {
            setUnlocking(false);
        }
    }

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card shadow">
                        <div className="card-body">
                            <h2 className="text-center mb-4">Account Unlock</h2>
            
            {unlocking && (
                <div className="alert alert-info" role="alert">
                    <div className="d-flex align-items-center">
                        <img 
                            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" 
                            alt="loading" 
                            className="me-2"
                        />
                        Unlocking your account...
                    </div>
                </div>
            )}

            {success && (
                <div className="alert alert-success" role="alert">
                    <h4 className="alert-heading">Success!</h4>
                    <p>{message}</p>
                    <hr />
                    <p className="mb-0">Redirecting to login page in 3 seconds...</p>
                </div>
            )}

            {error && (
                <div className="alert alert-danger" role="alert">
                    <h4 className="alert-heading">Unlock Failed</h4>
                    <p>{error}</p>
                    <hr />
                    <div>
                        <Link to="/login" className="btn btn-primary me-2">Go to Login</Link>
                        {token && (
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={handleUnlock}
                                disabled={unlocking}
                            >
                                Try Again
                            </button>
                        )}
                    </div>
                </div>
            )}

            {!token && !unlocking && (
                <div className="alert alert-warning" role="alert">
                    <h4 className="alert-heading">Invalid Unlock Link</h4>
                    <p>The unlock link appears to be invalid or incomplete. Please check your email for the correct unlock link.</p>
                    <hr />
                    <Link to="/login" className="btn btn-primary">Go to Login</Link>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}